import Bot from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import { AGENT_BOT_PERMISSIONS } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      meta: {
        permissions: ['administrator', AGENT_BOT_PERMISSIONS],
        connectionsNavigation: true,
        connectionSection: 'assistants',
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            permissions: ['administrator', AGENT_BOT_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
